<template>
    <pendo-router-link
        v-pendo-tooltip="{
            classes: 'side-nav-tooltip',
            content: tooltipContent,
            placement: 'right',
            arrow: true,
        }"
        pendo-analytics="orchestrate-nav-item-upsell"
        class="nav-option"
        :to="{ name: 'Orchestrate' }"
        :class="{ selected, expanded }"
        :aria-label="label"
        @click="$emit('toggle', $event)"
        @keyup.enter="$emit('toggle', $event)">
        <div class="nav-icon">
            <svg
                class="filled-icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 8.25L7 7C7 6.33696 7.21071 5.70107 7.58579 5.23223C7.96086 4.76339 8.46957 4.5 9 4.5L10 4.5"
                    stroke="var(--palette-gray-90)"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M7 15.75V17C7 17.663 7.21071 18.2989 7.58579 18.7678C7.96086 19.2366 8.46957 19.5 9 19.5H10"
                    stroke="var(--palette-gray-90)"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <rect
                    x="21"
                    y="16.75"
                    width="5.5"
                    height="7"
                    rx="1"
                    transform="rotate(90 21 16.75)"
                    fill="var(--palette-gray-90)"
                    stroke="var(--palette-gray-90)"
                    stroke-width="2" />
                <rect
                    x="21"
                    y="1.75"
                    width="5.5"
                    height="7"
                    rx="1"
                    transform="rotate(90 21 1.75)"
                    fill="var(--palette-gray-90)"
                    stroke="var(--palette-gray-90)"
                    stroke-width="2" />
                <rect
                    x="10"
                    y="9.25"
                    width="5.5"
                    height="7"
                    rx="1"
                    transform="rotate(90 10 9.25)"
                    fill="var(--palette-gray-90)"
                    stroke="var(--palette-gray-90)"
                    stroke-width="2" />
            </svg>
            <svg
                class="empty-icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7 8.25L7 7C7 6.33696 7.21071 5.70107 7.58579 5.23223C7.96086 4.76339 8.46957 4.5 9 4.5L10 4.5"
                    stroke="var(--palette-gray-90)"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M7 15.75V17C7 17.663 7.21071 18.2989 7.58579 18.7678C7.96086 19.2366 8.46957 19.5 9 19.5H10"
                    stroke="var(--palette-gray-90)"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <rect
                    x="21"
                    y="16.75"
                    width="5.5"
                    height="7"
                    rx="1"
                    transform="rotate(90 21 16.75)"
                    stroke="var(--palette-gray-90)"
                    stroke-width="2" />
                <rect
                    x="21"
                    y="1.75"
                    width="5.5"
                    height="7"
                    rx="1"
                    transform="rotate(90 21 1.75)"
                    stroke="var(--palette-gray-90)"
                    stroke-width="2" />
                <rect
                    x="10"
                    y="9.25"
                    width="5.5"
                    height="7"
                    rx="1"
                    transform="rotate(90 10 9.25)"
                    stroke="var(--palette-gray-90)"
                    stroke-width="2" />
            </svg>
        </div>
        <div
            v-show="expanded"
            class="nav-label">
            <span class="label-text">{{ label }}</span>
            <upsell-tag />
        </div>
    </pendo-router-link>
</template>

<script>
import PendoRouterLink from '@/vue-router/pendo-router-link.vue';
import { PendoTooltip } from '@pendo/components';
import UpsellTag from '@/common/tags/upsell-tag.vue';

export default {
    name: 'Orchestrate',
    compatConfig: {
        INSTANCE_LISTENERS: false,
    },
    components: {
        PendoRouterLink,
        UpsellTag,
    },
    directives: {
        PendoTooltip,
    },
    props: {
        selected: {
            type: Boolean,
            default: false,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['toggle'],
    computed: {
        tooltipContent () {
            if (this.expanded) return '';

            return this.$t('sideNav.Available upgrade: Orchestrate');
        },
        label () {
            return this.$t('sideNav.orchestrate.Orchestrate');
        },
    },
};
</script>

<style scoped lang="less">
@import '@/side-nav/nav.style.less';
</style>
